interface SpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

/** Small inline loading indicator for buttons and empty states. */
export default function Spinner({
  size = 14,
  color = "currentColor",
  className = "",
}: SpinnerProps) {
  return (
    <span
      className={`jf-spinner${className ? ` ${className}` : ""}`}
      style={{ width: size, height: size, color }}
      role="status"
      aria-label="Loading"
    >
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeOpacity="0.25"
          strokeWidth="3"
        />
        <path
          d="M12 3a9 9 0 0 1 9 9"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </span>
  );
}
